import { Pipe, PipeTransform } from '@angular/core';
import { newDate } from './../utils/date';
import {leftPadNum} from './../utils/util';

@Pipe({
  name: 'monthDayOnly'
})
export class MonthDayOnlyPipe implements PipeTransform {

  transform(value: any, args?: any): any {
    const reg = /([12]\d{3}-(0[1-9]|1[0-2])-(0[1-9]|[12]\d|3[01]))/g;
    const months = ['January', 'February', 'March', 'April', 'May', 'June', 'July',
      'August', 'September', 'October', 'November', 'December'];
    let str = '', dateRef;

    if (typeof value === 'string' && reg.test(value)) {
      const m = value.match(reg);
      const d = dateRef = newDate(m[0]);
      str = `${months[d.getMonth()]} ${d.getDate()}`;
    } else if (value instanceof Date) {
      dateRef = value;
      str = `${months[value.getMonth()]} ${value.getDate()}`;
    }
    if (args === 'MM/DD') {
      str = `${leftPadNum((dateRef.getMonth() + 1), 2)}/${leftPadNum(dateRef.getDate(), 2)}`;
    }
    return str;
  }
}
